import { IR2BRewardConfig } from '../../indigofair/data/IR2BRewardConfig';
import { SettingConst } from '../../types';

/**
 * Configuration(s) for R2B reward
 */
export const R2B_REWARD_CONFIG_220725 =
  'R2B_REWARD_CONFIG_220725' as SettingConst<
    'R2B_REWARD_CONFIG_220725',
    IR2BRewardConfig,
    'RETAILER'
  >;
